import { message } from 'antd';

export function showErrorMessage(text: string): void {
  message.error({
    content: text,
    className: 'errorMessage',
  });
}
